<div class="fsm">
    <div class="fsm-header">
        <div class="fsm-header-heading">
            <h4>{{ 'data-analytics.popup_header' | translate}}</h4>
        </div>
        <mat-dialog-actions class="dialog-close">
            <img src="assets/images/dialog-close.svg" alt="close" mat-dialog-close class="dialog-close-img"
                (click)="dialogClose()"  (keydown.enter)="dialogClose()"
                (keydown.space)="dialogClose()">
        </mat-dialog-actions>
    </div>
    <div class="fsm-body">
        <div class="subscription" *ngIf="subscriptionMessage">
            <p>{{subscriptionMessage}}</p>
        </div>
        <form (ngSubmit)="onSubmit()" [formGroup]="factorySelectionForm">
            <div class="form-group">
                <mat-form-field appearance="outline" class="fw">
                    <mat-label>
                        {{'data-analytics.select_cluster' | translate}}
                    </mat-label>
                    <input type="text" matInput formControlName="cluster" [matAutocomplete]="clusterAuto"
                        (ngModelChange)="autoCompleteCluster($event)">
                    <mat-autocomplete #clusterAuto="matAutocomplete">
                        <mat-option *ngFor="let cluster of uniqueClusterList" (click)="onClusterChange(cluster)"
                            (keydown.enter)="onClusterChange(cluster)" (keydown.space)="onClusterChange(cluster)">
                            {{cluster.name}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-hint class="error" *ngIf="f.cluster.invalid && (f.cluster.dirty || f.cluster.touched)">
                        {{'data-analytics.select_cluster' | translate}}!
                    </mat-hint>
                </mat-form-field>
            </div>

            <div class="form-group">
                <mat-form-field appearance="outline" class="fw">
                    <mat-label>
                        {{'data-analytics.select_factory' | translate}}
                    </mat-label>
                    <input type="text" matInput formControlName="factory" [matAutocomplete]="factoryAuto"
                        (ngModelChange)="autoCompleteFactory($event)">
                    <mat-autocomplete #factoryAuto="matAutocomplete">
                        <mat-option *ngFor="let factory of filteredFactoryList"
                            (keydown.enter)="onFactoryChange(factory)" (keydown.space)="onFactoryChange(factory)"
                            (click)="onFactoryChange(factory)">
                            {{factory.name}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-hint class="error" *ngIf="f.factory.invalid && (f.factory.dirty || f.factory.touched)">
                        {{'data-analytics.select_factory' | translate}}!
                    </mat-hint>
                </mat-form-field>
            </div>

            <div class="form-action">
                <button mat-raised-button class="btn" [class.btn-fsm]="isSelected" [disabled]="!isSelected"
                    id="btnSubmit" type="submit">
                    {{'data-analytics.select_btn' | translate}}
                </button>
            </div>
        </form>
    </div>
</div>